import React, { useState, useEffect, useRef } from 'react';
import './ChatbotWidget.scss';
import { useSelector, useDispatch } from "react-redux";
import EncuestaChatBot from "../EncuestaChatBot/EncuestaChatBot";
import { sendMessageChatbot } from '../../actions/usuarioActions';


const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
const buildUrl = (path) =>
  `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;

const CHAT_URL = buildUrl("/admin/chatbot");

const MSG_SERVICIO_CAIDO = "El asistente no está disponible en este momento. Inténtalo más tarde.";

const ChatbotWidget = () => {
  const [open, setOpen] = useState(false);

  const initialMessages = [
    { from: 'bot', text: 'Hola 👋 Soy tu asistente virtual. ¿En qué te ayudo?' }
  ];

  const [messages, setMessages] = useState(initialMessages);
  const [input, setInput] = useState('');
  const [authLoading, setAuthLoading] = useState(false); // ✅ opcional
  //Encuesta
  const [openEncuesta, setOpenEncuesta] = useState(false);
  const [encuestaCompletada, setEncuestaCompletada] = useState(false);

  const dispatch = useDispatch();


  const widgetRef = useRef(null);
  const buttonRef = useRef(null);
  const endOfMessagesRef = useRef(null);



  const usuarioState = useSelector(state => state.usuario);

  // ✅ idUsuario real (ajusta cuál usar: id_estudiante o id_u_estudiante)
  const idUsuario = usuarioState?.usuario?.id_usuario;


  // ✅ respondio viene como "0" / "1"
  const respondioRaw = usuarioState?.detalleNivel?.[0]?.respondio;

  // "0" = NO respondió -> debe responder encuesta (true)
  // "1" = SÍ respondió -> NO debe responder (false)
  const debeResponderEncuesta = respondioRaw === "0" && !encuestaCompletada;

  //Obtener todo el use Selector
  /*useEffect(() => {
    console.log("state.usuario COMPLETO =>", usuarioState);
  }, [usuarioState]);*/



  const quickQuestions = [
    '¿Cómo ver mis cursos?',
    'Quiero realizar un pago',
    '¿Cuándo son mis próximas evaluaciones?',
    '¿Dónde veo mis convocatorias?',
    '¿Cómo contacto a soporte?'
  ];





  // ✅ Cerrar al click afuera (solo mobile)
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (window.innerWidth > 770) return;

      if (
        widgetRef.current &&
        !widgetRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('pointerdown', handleClickOutside);
    return () => document.removeEventListener('pointerdown', handleClickOutside);
  }, [open]);


  // ✅ 2.5) Scroll automático al último mensaje
  useEffect(() => {
    if (!open) return;

    endOfMessagesRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  }, [messages, open]);


  // ✅ 3) Enviar mensaje
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const text = input;
    setInput('');
    await sendText(text);
  };


  const sendText = async (text) => {
    const userText = text?.trim();
    if (!userText) return;

    // pinta mensaje del usuario
    setMessages(prev => [...prev, { from: 'user', text: userText }]);

    try {

      const res = await dispatch(sendMessageChatbot({ mensaje: userText, id_usuario: idUsuario }))

      const botReply = res.respuesta || res.mensaje || res.msg || 'Sin respuesta';
      setMessages(prev => [...prev, { from: 'bot', text: botReply }]);

    } catch (error) {
      console.error(error);
      setMessages(prev => [...prev, { from: "bot", text: MSG_SERVICIO_CAIDO }]);
    }
  };


  const clearChat = () => setMessages(initialMessages);

  const handleFabClick = async () => {
    if (debeResponderEncuesta) {
        setOpenEncuesta(true);
      return;
    }

    setOpen(prev => !prev);
  };


  return (
    <>
      <button
        ref={buttonRef}
        className="fab-chatbot"
        onClick={handleFabClick}
        type="button"
      >
        <img
          src="/images/ChatBotIcom.png"
          alt="AIXBOT"
          className="bot-logo"
        />
      </button>

      {respondioRaw == "0" && openEncuesta && 
        <EncuestaChatBot
          open={openEncuesta}
          idUsuario={idUsuario}
          setOpen ={setOpenEncuesta}
          onCloseAfterSubmit={() => {
            setEncuestaCompletada(true);   // ✅ esto evita que vuelva a abrirse
            setOpenEncuesta(false);
            setOpen(true);
          }}
        />
      }


      {open && (
        <div ref={widgetRef} className="chatbot-window">
          <div className="chatbot-header">
            <div className="chatbot-title">
              <div className="chatbot-brand">AIXBOT</div>
              <div className="chatbot-subtitle">Asistente INEDI</div>
            </div>

            <button
              type="button"
              className="chatbot-close"
              onClick={() => setOpen(false)}
              aria-label="Cerrar chat"
            >
              Cerrar
            </button>
          </div>

          <div className="chatbot-body">
            {messages.map((m, i) => (
              <div key={i}>
                <div className={`msg ${m.from}`}>{m.text}</div>

                {/* ✅ Quick replies SOLO debajo del primer mensaje del bot */}
                {i === 0 && m.from === 'bot' && (
                  <div className="quick-replies">
                    {quickQuestions.map((q, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className="quick-reply"
                        onClick={() => sendText(q)}
                      >
                        {q}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <div ref={endOfMessagesRef} />
          </div>

          <form className="chatbot-input" onSubmit={sendMessage}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Escribe tu consulta..."
            />

            <button
              type="button"
              className="btn-chat btn-clear"
              onClick={clearChat}
              title="Limpiar conversación"
            >
              Limpiar
            </button>

            <button
              type="submit"
              className="btn-chat btn-send"
              title="Enviar mensaje"
              disabled={!input.trim() || authLoading}
            >
              {authLoading ? '...' : 'Enviar'}
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default ChatbotWidget;
